/**
* @description
* # name controller --> reportStudentController
* # As Controller --> reportStudent
*/

export default class reportStudentController {
	constructor($scope,ngNotify,UserInfoConstant,$state,$filter,studentsServices,ambitsServices, coresServices, $modal, evaluationsServices, SERVICE_URL_CONSTANT, $window) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$modal = $modal
		this.$window = $window
		this.baseUrl = SERVICE_URL_CONSTANT
		this.studentsServices = studentsServices.services
		this.ambitsServices = ambitsServices.services
		this.coresServices = coresServices.services
		this.servicesPeriod = evaluationsServices.servicesPeriod
		this.$state = $state
		this.buttonActions = true
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.expandPanels = true
		this.levelId = 1
		this.$scope.periodSelect = null
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		this.params = {
			level_id: this.levelId,
			concept_id: this.conceptId,
			user_id: this.user_id
		}
		
		this.getPeriod()
	}

	getPeriod(){
		this.servicesPeriod.getPeriod().$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
				this.params.period_id = 3
				this.getStudentByEducator()
				this.getCoresbyUserStudent()
			}else{
				this.periodList = dataReturn.results
				this.periodList.map((period) => {
					if(period.is_current ){
						this.$scope.periodSelect = period.id_code
					}
				})

				this.params.period_id = this.$scope.periodSelect
				this.getStudentByEducator()
				this.getCoresbyUserStudent()
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getStudentByEducator(){
		this.studentsServices.getStudentByEducator(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.studentByEducatorLevel = dataReturn.results
				this.student = this.studentByEducatorLevel.student ? this.studentByEducatorLevel.student : null
				this.educator = this.studentByEducatorLevel.educator ? this.studentByEducatorLevel.educator.educator : null
				this.levelName = this.student.enabled_students[0].level.ds_name
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getCoresbyUserStudent(){
		this.ambitsServices.getCoresbyUserStudent(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.cores = []
				this.coresList = dataReturn.results
				this.coresList.map((core) => {
					const response = []
					core.learning_objectives.forEach(learning => {
						learning.indicators.map(indicator => {
							let diagnostica_id = null
							let type_evaluation_diag_id = null
							let formativa_id = null
							let type_evaluation_form_id = null
							let sumativa_id = null
							let type_evaluation_sum_id = null

							indicator.evaluations.forEach(evaluation => {
								if (evaluation.id_type_grade === 1) {
									diagnostica_id = evaluation.id_type_grade
									type_evaluation_diag_id = evaluation.id_type_evaluation
								}

								if (evaluation.id_type_grade === 2) {
									formativa_id = evaluation.id_type_grade
									type_evaluation_form_id = evaluation.id_type_evaluation
								}

								if (evaluation.id_type_grade === 3) {
									sumativa_id = evaluation.id_type_grade
									type_evaluation_sum_id = evaluation.id_type_evaluation
								}
							})
							response.push({
								id_code: indicator.id_code,
								ds_name: indicator.ds_name,
								id_learning: learning.id_code,
								ds_learning: learning.ds_name,
								diagnostica_id: diagnostica_id,
								type_evaluation_diag_id: type_evaluation_diag_id,
								formativa_id: formativa_id,
								type_evaluation_form_id: type_evaluation_form_id,
								sumativa_id: sumativa_id,
								type_evaluation_sum_id: type_evaluation_sum_id
							})
						})
					})
					this.cores.push({
						id_code: core.id_code,
						ds_name: core.ds_name,
						learning_objectives: response
					})						
				})
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getCoresbyUserStudentDownload(){
		const path = this.baseUrl.parvulo + '/ambits/cores-by-user-download?concept_id=' + this.params.concept_id + '&level_id=' + this.params.level_id + '&period_id=' + this.params.period_id + '&user_id=' + this.params.user_id
		this.$window.open(path)
	}

	selectChanged(periodSelect){
		this.$scope.periodSelect = periodSelect
		this.params.period_id = periodSelect
	}

	edit(){
		this.$scope.editSave = true
		this.$scope.edit = false
		this.$scope.titleList = false
		this.$scope.titleEdit = true
		this.$scope.isDisabled = false
	}

	cancelEdit(){
		this.$scope.editSave = false
		this.$scope.edit = true
		this.$scope.titleList = true
		this.$scope.titleEdit = false
		
	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
reportStudentController.$inject=['$scope','ngNotify','UserInfoConstant','$state','$filter', 'studentsServices', 'ambitsServices', 'coresServices', '$modal', 'evaluationsServices', 'SERVICE_URL_CONSTANT', '$window']


// WEBPACK FOOTER //
// ./src/app/reports/report-student/reportStudentController.js